import { ChangeDetectionStrategy, Component, Output } from "@angular/core";
import { NzCheckboxWrapperComponent } from "ng-zorro-antd/checkbox";

@Component({
  selector: "ui-checkbox-wrapper",
  exportAs: "uiCheckboxWrapper",
  templateUrl: "checkbox-wrapper.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UiCheckboxWrapperComponent extends NzCheckboxWrapperComponent {
  @Output() public readonly checkboxWrapperOnChange = this.nzOnChange;
}
